var _excluded = ["children", "className", "isTitle", "href", "anchorAttributes", "lastItem"];
var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Footer/InlineList/InlineListItem.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext } from 'react';
import classnames from 'classnames';
import useStyles from './useStyles';
import { SMFooterContext } from '../SMFooterContext';
import makeLinkStatic from '../FooterLinks/helpers/makeLinksStatic';
var InlineListItem = function InlineListItem(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? '' : _ref$children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$isTitle = _ref.isTitle,
    isTitle = _ref$isTitle === void 0 ? false : _ref$isTitle,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '' : _ref$href,
    _ref$anchorAttributes = _ref.anchorAttributes,
    anchorAttributes = _ref$anchorAttributes === void 0 ? null : _ref$anchorAttributes,
    _ref$lastItem = _ref.lastItem,
    lastItem = _ref$lastItem === void 0 ? false : _ref$lastItem,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles({
      isTitle: isTitle
    }),
    inlineListItem = _useStyles.inlineListItem,
    inlineListItemBullet = _useStyles.inlineListItemBullet,
    inlineListItemAnchor = _useStyles.inlineListItemAnchor;
  var _useContext = useContext(SMFooterContext),
    makeFooterLinksStatic = _useContext.makeFooterLinksStatic;
  var showBullet = !isTitle && !lastItem;
  var inlineListItemAnchorMerged = classnames(inlineListItemAnchor, className);
  return /*#__PURE__*/React.createElement("li", Object.assign({
    className: inlineListItem
  }, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 5
    }
  }), !!href ? /*#__PURE__*/React.createElement("a", Object.assign({
    className: inlineListItemAnchorMerged,
    href: makeFooterLinksStatic ? makeLinkStatic(href) : href
  }, anchorAttributes, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 11
    }
  }), children) : children, showBullet ? /*#__PURE__*/React.createElement("span", {
    className: inlineListItemBullet,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 9
    }
  }, "\u2022") : null);
};
export default InlineListItem;
//# sourceMappingURL=InlineListItem.js.map